import React from 'react';
import PropTypes from 'prop-types';
import RegexFilteredInput from './RegexFilteredInput';

const regExAlphaNumeric = /^[0-9a-zA-Z]+$/;
const regExAlphaNumericWithSpecialChars = /^[0-9a-zA-Z '-;.\\]+$/;

const AlphaNumericInput = ({ useSpecialCharacters, ...other }) => (
  <RegexFilteredInput
    regex={useSpecialCharacters ? regExAlphaNumericWithSpecialChars : regExAlphaNumeric}
    {...other}
  />
);

AlphaNumericInput.propTypes = {
  useSpecialCharacters: PropTypes.bool,
  other: PropTypes.object,
};

AlphaNumericInput.defaultProps = {
  other: null,
  useSpecialCharacters: false,
};

export default AlphaNumericInput;
